import { connect } from 'react-redux';
import ParticipantsEditForm from './ParticipantsEditForm';
import CRUDAction from '../../../actions/participant';

export default connect(
  ( { participant : { model, loadingItem}} ) => ({
    model,
    loading: loadingItem,
    isAbleToDelete: model && !model.isNew(),
    initialValues: model || {}
  }),
  dispatch => ({
    onClose: () => dispatch(CRUDAction.onCloseEditForm()),
    remove: (item) => dispatch(CRUDAction.remove(item)),
    save: (item) => dispatch(CRUDAction.save(item))
  })
)(ParticipantsEditForm);



// WEBPACK FOOTER //
// ./src/components/Participants/ParticipantsEditForm/index.js